import { arkScope } from '@/api/workspace/endpoints/arkConfig.ts';

const ColumnStateValidator = arkScope.type({
  autoColumState: arkScope.type({ width: 'number' }),
  columnState: arkScope
    .type({
      colId: 'string',
      hide: 'boolean',
      'width?': 'number',
      'sort?': '"asc" | "desc"',
      'sortIndex?': 'number',
    })
    .array(),
});
export const SavedBlotterValidator = arkScope.type({
  panelIsOpen: 'boolean',
  panelHeight: 'number',
  activeTab: "'Cash' | 'Option' | 'Order' | 'Accumulator'",
  cashTab: ColumnStateValidator,
  optionTab: ColumnStateValidator,
  orderTab: ColumnStateValidator,
  accumulatorTab: ColumnStateValidator,
});
export type SavedBlotter = typeof SavedBlotterValidator.infer;
